<template>
	<v-menu
		ref="menu"
		v-model="menuDatePicker"
		:close-on-content-click="false"
		:return-value.sync="selectedDate"
		transition="scale-transition"
		offset-y
		:disabled="disabledInput"
		min-width="auto"
		eager
	>
		<template v-slot:activator="{ on, attrs }">
			<div
				class="date-viewer"
				v-bind="attrs"
				v-on="on"
			>
				<div v-if="selectedDate" class="font-weight-bold body-2" :class="{'text--disabled': disabledInput}">
					{{selectedDate | toDate}}
				</div>
				<div v-else>
					Seleccionar
				</div>
			</div>
		</template>
		<v-date-picker
			v-model="selectedDate"
			no-title
			scrollable
			:first-day-of-week="1"
			locale="es-cl"
			:events="holidays"
			:picker-date.sync="pickerDate"
			event-color="red lighten-1"
			@input="(date) => $refs.menu.save(date)"
			@change="updateDate"
			class="pb-4"
		/>
	</v-menu>
</template>

<script>
import moment from "moment"
import _debounce from 'lodash/debounce'
import {getHolidays} from '@/helpers/api/schedule'
import {updateDocumentRevision} from '@/helpers/api/preprojects'

export default {
	name: 'DocumentDateSelector',
	computed: {
		disabledInput(){
			return !this.canEditInfo || this.delivered
		},
		holidays(){
			return this.currentYearHolidays || this.$store.state.general.holidayDays
		},
		canEditInfo(){
			return this.editPermission
			// Puede editar sólo si tiene permiso y si no hay un contrato firmado en la línea de proyectos
			// return this.editPermission && !this.preproject?.pl_signed_contract
		},
		editPermission(){
			return this.$checkPermissions(['edit_preprojects'])
		},
    preproject() {
      return this.$store.state.preprojects.preProject
    },
		crm(){
			return this.$store.state.crm.conversation
		},
    main_element() {
      return this.preproject || this.crm
    },
		documentInfo(){
			const found = this.main_element?.documents.find((document) => {
				return document.document_type_id == this.documentTypeId
			})
			return found
		},
		documentDate(){
			const found = this.main_element?.documents.find((document) => {
				return document.document_type_id == this.documentTypeId
			})
			if(found){
				const dateTypeMapping = {
					1: 'request_date',
					2: 'max_date',
					3: 'delivered_date'
				}
				if (this.dateType in dateTypeMapping && found[dateTypeMapping[this.dateType]]) {
					return found[dateTypeMapping[this.dateType]]
				}
			}
			return null
		}
	},
	props: {
		documentTypeId: {
			type: Number,
			required: true
		},
		dateType: {
			type: Number,
			required: true
		},
		loading: {
			type: Function,
			required: true
		},
		delivered: {
			function: Boolean,
			default: false
		}
	},
	watch: {
		currentYear(newValue, oldValue){
			if(newValue != oldValue && this.menuDatePicker){
				this.updateHolidays()
			}
		},
		pickerDate(newValue){
			if(newValue){
				this.currentYear = moment(newValue).format('YYYY')
			}
		},
		documentDate(newValue){
			if(newValue){
				this.selectedDate = newValue
			}
		},
		menuDatePicker(newValue){
			if(newValue){
				this.updateHolidays()
			}
		},
	},
	data() {
		return{
			debouncers: {},
			menuDatePicker: false,
			selectedDate: null,
			currentYear: 2024,
			pickerDate: null,
			currentYearHolidays: null,
		}
	},
	mounted(){
		this.selectedDate = this.documentDate
	},
	methods: {
		debounceGetPreProject: _debounce(function(){ this.getPreProject() }, 1000),
		getPreProject(){
			this.$store.dispatch('preprojects/getPreProject', { 
				preproject_id: this.preproject?.id,
				showLoader: false 
			})
		},
		debounceGetCrm: _debounce(function(){ this.getCrm() }, 1000),
		getCrm(){
			this.$store.dispatch('crm/getConversation', {
				conversation_id: this.crm?.id,
				showLoader: false 
			})
		},
		async updateHolidays(){
			const holidays = await getHolidays({year: this.currentYear})
			if(holidays.code == 200){
				this.currentYearHolidays = holidays.events
			}
		},
		async updateDate(){
			this.loading(true)
			let data = {
				document_type_id: this.documentTypeId,
				preproject_id: this.preproject?.id,
				crm_id: this.crm?.id,
			}
			const dateTypeMapping = {
				1: 'request_date',
				2: 'max_date',
				3: 'delivered_date'
			}

			if (this.dateType in dateTypeMapping) {
				data[dateTypeMapping[this.dateType]] = this.selectedDate
			}
			await updateDocumentRevision(data)
			this.loading(false)
			if(this.preproject) this.debounceGetPreProject()
			if(this.crm)  this.debounceGetCrm()
		}
	}
}
</script>